import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from '../../../core/services/data.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { MatTableDataSource } from '@angular/material/table';
import { SchemaInfoModel } from 'src/app/core/models/classes/schema-info';

@Component({
  selector: 'app-schemainfo',
  templateUrl: './schemainfo.component.html',
  styleUrls: ['./schemainfo.component.scss']
})

export class SchemainfoComponent {
  inProgress : boolean = false;
  schemaInfoDataSource;
  schemaInfo: string[] = ['num', 'objname', 'objtyp', 'instversion', 'avlbversion','status'];

  constructor(      
    private _snackBar: MatSnackBar,
    private dataService: DataService,
    private settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    this.settingsService.getSchemaInfo().subscribe({
      next: (data : SchemaInfoModel[]) => {   
        data.forEach(item => {
          if(item.status !== "OK"){
            item.status = "Error";
          }

          if(item.availableVersion === null){
            item.availableVersion = "-";
          }
        })            
        this.schemaInfoDataSource = new MatTableDataSource<SchemaInfoModel>(data);         
        this.schemaInfoDataSource.filterPredicate = (row: SchemaInfoModel, filter: string): boolean => {
          const lcFilter = filter.trim().toLowerCase();
          return (
            (row.name || '').toLowerCase().includes(lcFilter) ||
            (row.status || '').toLowerCase().includes(lcFilter) ||
            (row.objectType || '').toLowerCase().includes(lcFilter) ||
            (row.installedVersion || '').toLowerCase().includes(lcFilter) ||
            (row.availableVersion || '').toLowerCase().includes(lcFilter)
          );
        };     
      },
    });
  }
  
  schemaNameFilter(event: Event) {
    this.schemaInfoDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
   }

  confirmRefreshSchema(): void {
    this.inProgress = true;
    this.dataService.runRefreshSchema().subscribe({
      next: (data) => {
        if(data.status === 200){
          this._snackBar.open($localize `Refresh Schema successful`, '', {
            duration: 3000
          });
          this.inProgress = false;
        }
        else{
          this._snackBar.open($localize `Refresh Schema failed`, '', {
            duration: 3000
          });
          this.inProgress = false;
        }
      },
    });
  }
}